import { css } from '@emotion/react';

export const FlexStyle = (
	{
		alignItemsCenter,
		alignItemsBetween,
		alignItemsFlexEnd,
		justifyContentCenter,
		justifyContentBetween,
		justifyContentFlexEnd,
		centered,
		full,
		grow,
		shrink,
		fullHeight,
		fullWidth,
		wrap,
		directionColumn,
	}: {
		alignItemsCenter?: boolean;
		alignItemsBetween?: boolean;
		alignItemsFlexEnd?: boolean;
		justifyContentCenter?: boolean;
		justifyContentBetween?: boolean;
		justifyContentFlexEnd?: boolean;
		centered?: boolean;
		full?: boolean;
		grow?: boolean;
		shrink?: boolean;
		fullHeight?: boolean;
		fullWidth?: boolean;
		wrap?: boolean;
		directionColumn?: boolean;
	} = {
		alignItemsCenter: false,
		alignItemsBetween: false,
		alignItemsFlexEnd: false,
		justifyContentCenter: false,
		justifyContentBetween: false,
		justifyContentFlexEnd: false,
		full: false,
		centered: false,
		grow: false,
		shrink: true,
		fullHeight: false,
		fullWidth: false,
		wrap: false,
		directionColumn: false,
	},
) => css`
	display: flex;
	flex-grow: ${grow ? 1 : 0};
	flex-shrink: ${shrink ? 1 : 0};

	${directionColumn &&
	css`
		flex-direction: column;
	`};

	${wrap &&
	css`
		flex-wrap: wrap;
	`};

	${(alignItemsCenter || centered) &&
	css`
		align-items: center;
	`};

	${alignItemsBetween &&
	css`
		align-items: space-between;
	`};

	${alignItemsFlexEnd &&
	css`
		align-items: flex-end;
	`};

	${(justifyContentCenter || centered) &&
	css`
		justify-content: center;
	`};

	${justifyContentBetween &&
	css`
		justify-content: space-between;
	`};

	${justifyContentFlexEnd &&
	css`
		justify-content: flex-end;
	`};

	${(fullHeight || full) &&
	css`
		height: 100%;
	`};

	${(fullWidth || full) &&
	css`
		width: 100%;
	`};
`;
